__turbopack_context__.v({
  "vertical_offset": "imCtkW_vertical_offset",
  "watch_video_button": "imCtkW_watch_video_button",
  "watch_video_button_icon": "imCtkW_watch_video_button_icon",
  "watch_video_button_text": "imCtkW_watch_video_button_text",
});
